module.exports = __webpack_public_path__ + "static/media/drop-down.ad111055.svg";